<template>
  <section class="section">
    <div class="buttons">
      <b-button @click="addArtiste">Add Artiste</b-button>
      <b-button @click="editArtiste">Edit Artiste</b-button>
    </div>

    <br />
    <div v-for="item in e" v-bind:key="item.id">
      <div class="card">
        <div class="card-image">
          <figure class="image is-2by2">
            <img :src="item.cover" alt="Placeholder image" />
          </figure>
        </div>
        <div class="card-content">
          <div class="media">
            <div class="media-left">
              <figure class="image is-48x48">
                <img :src="item.altCover" alt="Placeholder image" />
              </figure>
            </div>
            <div class="media-content" v-if="!edit">
              <p class="title is-4">{{ item.stageName }}</p>
              <p class="subtitle is-6">{{ item.firstName }} {{ item.lastName }}</p>
            </div>
            <div class="media-content" v-if="edit">
              <b-field label="Stage Name">
                <b-input v-model="item.stageName"></b-input>
              </b-field>

              <p class="subtitle is-6">{{ item.firstName }} {{ item.lastName }}</p>
            </div>
          </div>

          <div class="content" v-if="!edit">
            {{item.biography ? item.biography : "(bio missing)"}}
            <br />
          </div>
          <div v-if="edit">
            <b-input maxlength="800" type="textarea" v-model="item.biography"></b-input>
            <!-- <textarea v-model="item.biography"></textarea> -->
          </div>
          <footer class="card-footer">
            <a href="#" class="card-footer-item" @click="saveArtiste" v-if="edit">Save</a>
            <a href="#" class="card-footer-item" @click="editArtiste" v-if="!edit">Edit</a>
            <a href="#" class="card-footer-item">Delete</a>
          </footer>
        </div>
      </div>
      <br />
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import firebase from 'firebase';

export default {
  name: 'home',
  data() {
    return {
      e: [],
      edit: false,
    };
  },
  mounted() {
    firebase
      .firestore()
      .collection('artistes')
      .get()
      .then((snapshot) => {
        snapshot.docs.map((d) => {
          const artiste = d.data();

          if (artiste.cover) {
            this.e.push(artiste);
          }

          return this.e;
        });
      });
  },
  methods: {
    editArtiste() {
      this.edit = !this.edit;
    },
    addArtiste() {
      this.$router.push('/add');
    },
  },
};
</script>
